module.exports = __webpack_public_path__ + "static/media/status-filled.09d0cc77.svg";